import styled from 'styled-components/macro'

const Divider = styled.div`
  border-bottom: 1px solid #ccc;
`
export default Divider
